import DaqEmpty from '@components/daq-empty';
import EmptyDark from '@assets/images/weather/empty-dark.png';

const WeatherEmpty = () => {
  return <DaqEmpty image={EmptyDark}></DaqEmpty>;
};

export default WeatherEmpty;
